import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';
import { Request } from './Request';

export class RemoveIdentityProviderRequest extends Request<{}, ISiteSAMLConfiguration> {
  constructor() {
    super('removeIdentityProvider', {});
  }
}
